import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { ErrorHandlerService } from '@core/services/error-handler.service';
import { TextareaModule } from 'primeng/textarea';

@Component({
  selector: 'app-error-dialog',
  imports: [DialogModule, ButtonModule, TranslatePipe, TextareaModule],
  templateUrl: './error-dialog.component.html',
})
export class ErrorDialogComponent {
  protected readonly errorHandlerService = inject(ErrorHandlerService);

  refresh(): void {
    window.location.reload();
  }

  copyRequestId(): void {
    const id = this.errorHandlerService.requestId();
    if (id) navigator.clipboard.writeText(id);
  }
}
